import { Avatar, Box, NavList } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import {
  getStoredImage,
  getWatercraftImage,
} from '../../../../../services/image';
import { Vessel } from '../../../../../services/store/modules/vessels/models';
import IconWithTextLockup from '../../../../lockups/IconWithTextLockup/IconWithTextLockup';
import BlueCircleWrapper from '../../../../shared/BlueCircleWrapper/BlueCircleWrapper';
import { motorBoat, ReactSvg } from '../../../../shared/vector-images';
import { formatVesselRecordLength } from '../../../Vessels/utils/vessel-length';
import { getWatercraftName } from '../../../Vessels/utils/watercraft-display';
import { formatRiskVesselLengthDisplay } from '../../helpers/risk/risk-forecast-display';

interface RiskForecastInfoPanelProps {
  vesselLength: number;
  selectedVessel?: Vessel;
  watercraftType?: string;
  onClickEdit: () => void;
}

const RiskForecastInfoPanel: FC<RiskForecastInfoPanelProps> = ({
  vesselLength,
  selectedVessel,
  watercraftType,
  onClickEdit,
}) => {
  const theme = useTheme();

  const heading = 'Your watercraft';
  const lengthDisplay = formatRiskVesselLengthDisplay(vesselLength);
  const description = selectedVessel
    ? [
        getWatercraftName(selectedVessel),
        formatVesselRecordLength(selectedVessel),
      ]
        .filter(Boolean)
        .join(' · ')
    : lengthDisplay;

  const renderManualImage = () => {
    if (watercraftType) {
      return getWatercraftImage(watercraftType, 40);
    }

    return (
      <BlueCircleWrapper iconSize={20}>
        <Box mt="-3px">
          <ReactSvg
            toDisplay={motorBoat()}
            options={{
              fillColor: theme.colors.secondary,
            }}
            width={20}
            height={20}
          />
        </Box>
      </BlueCircleWrapper>
    );
  };

  const image = selectedVessel ? (
    selectedVessel.image ? (
      <Avatar src={getStoredImage(selectedVessel.image, 40)} />
    ) : (
      getWatercraftImage(selectedVessel.watercraft_type, 40)
    )
  ) : (
    renderManualImage()
  );

  return (
    <Box width="100%">
      <Box border="1px solid" borderColor="line" borderRadius="5px" p="2">
        <NavList grouped edge>
          <NavList.Item
            onClick={onClickEdit}
            chevron
            data-testid="risk-forecast-watercraft-selector"
          >
            <IconWithTextLockup
              image={image}
              emphasis="description"
              heading={heading}
              description={description}
              descriptionColor="black"
            />
          </NavList.Item>
        </NavList>
      </Box>
    </Box>
  );
};

export default RiskForecastInfoPanel;
